export const CONSENT_APP_TOKEN_QUERY_PARAM_NAME = 'token'
export const CONNECTED_APP_ID_PARAM_NAME = 'appId'

export enum McpPermission {
  AccountView = 'mcp:account:view',

  SmsView = 'mcp:sms:view',
  SmsSend = 'mcp:sms:send',

  ContactsView = 'mcp:contacts:view',
  ContactsManage = 'mcp:contacts:manage',

  GroupsView = 'mcp:groups:view',
  GroupsManage = 'mcp:groups:manage',

  TagsView = 'mcp:tags:view',
  TagsManage = 'mcp:tags:manage',
}

export enum McpPermissionBadges {
  WRITE = 'write',
  USES_CREDIT = 'usesCredit',
}

export enum ConsentAuthorizeCompleteDecision {
  ALLOW = 'allow',
  DENY = 'deny',
}

// https://gitlab.textmagic.dev/backend/php/textmagic/-/blob/master/src/Service/OAuth2Server/TrustedClientInfoResolver.php
export enum McpTrustedBrand {
  CLAUDE = 'claude',
  OPEN_AI = 'openai',
  CHAT_GPT = 'chatgpt',
  CURSOR = 'cursor',
  MCP_JAM = 'mcpjam',
  ANTIGRAVITY = 'antigravity',
  VSCODE = 'vscode',
  COPILOT = 'copilot',
  WINDSURF = 'windsurf',
  CLINE = 'cline',
  GOOGLE = 'google',
}

export type ConsentAuthorizeCompletePayload = {
  token: string
  action: ConsentAuthorizeCompleteDecision
}

export type ConsentAuthorizeCompleteResponse = {
  redirectUri: string
}
